import keys from '@debbie/common/dist/cache/keys.js';
import { FIKSyntax, PaymentOptionType, PaymentOptionTypeToProviderMap, genWebhookEventAPIPath, } from '@debbie/common/dist/collectors/index.js';
import { Currency } from '@debbie/common/dist/index.js';
import { Provider } from '@debbie/common/dist/payment-methods/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as paymentMethodsAPI from '@debbie/cortex/dist/api/payment-methods.js';
import { collectorsEntity } from '@debbie/cortex/dist/collectors/index.js';
import { notification } from '@debbie/cortex/dist/notifications.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SelectBadge from 'react-select';
import { styled } from 'styled-components';
import { APIBASE } from '../config.js';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import X from './Icons/X.js';
import { Alert, Badge, Button, Checkbox, CopyToClipboard, ExclusiveContent, Input, Select, } from './index.js';
let tId = null;
const PaymentOptions = (props) => {
    const lang = useSelector((s) => s.lang);
    const [paymentOptions, setPO] = useState(props.options);
    const setPaymentOptions = (u) => {
        setPO(u);
        save(u);
    };
    const setPaymentOptionDetails = (index, details) => {
        setPaymentOptions(paymentOptions.map((paymentOption, i) => {
            if (index === i) {
                paymentOption.details = {
                    ...paymentOption.details,
                    ...details,
                };
            }
            return paymentOption;
        }));
    };
    const save = (po) => {
        if (tId) {
            clearTimeout(tId);
        }
        tId = setTimeout(() => {
            if (props.onChange) {
                props.onChange(po);
            }
        }, 600);
    };
    return (React.createElement(React.Fragment, null,
        paymentOptions.map((paymentOption, i) => (React.createElement(PaymentOptionsStyled, { key: paymentOption.id },
            React.createElement("div", { style: { margin: '-10px 0 10px 0' } },
                React.createElement(X, { style: { cursor: 'pointer', float: 'right' }, onClick: () => {
                        setPaymentOptions(paymentOptions.filter((_, index) => index !== i));
                    } }),
                React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.paymentOptionTypes[paymentOption.type])),
            PaymentOptionTypeToProviderMap[paymentOption.type] && (React.createElement(Checkbox, { checkMark: true, checked: paymentOption.isActive, placeholder: lang.paymentOptions.isActive, onChange: (e) => {
                    if (confirm(lang.paymentOptions.confirmChangeOfPaymentGateway)) {
                        setPaymentOptions(paymentOptions.map((paymentOption, index) => {
                            if (index === i) {
                                return {
                                    ...paymentOption,
                                    isActive: e.target.checked,
                                };
                            }
                            else if (paymentOption.isActive) {
                                return {
                                    ...paymentOption,
                                    isActive: !e.target.checked,
                                };
                            }
                            return paymentOption;
                        }));
                    }
                } })),
            React.createElement(Checkbox, { checked: Array.isArray(paymentOption.currencies), placeholder: lang.paymentOptions.currencySpecific, onChange: (e) => {
                    setPaymentOptions(paymentOptions.map((paymentOption, index) => {
                        if (index === i) {
                            return {
                                ...paymentOption,
                                currencies: e.target.checked ? [] : undefined,
                            };
                        }
                        return paymentOption;
                    }));
                }, setting: true }),
            Array.isArray(paymentOption.currencies) && (React.createElement("div", { style: {
                    marginBottom: `${THEME.GRID_SPACING}px`,
                } },
                React.createElement(SelectBadge, { value: paymentOption.currencies.map((currency) => ({
                        label: currency,
                        value: currency,
                    })), isMulti: true, placeholder: lang.paymentOptions.currencies, classNamePrefix: "select", options: Object.values(Currency).map((currency) => ({
                        label: currency,
                        value: currency,
                    })), onChange: (val) => {
                        const selected = val ? val.map((v) => v.value) : [];
                        setPaymentOptions(paymentOptions.map((paymentOption, index) => {
                            if (index === i) {
                                return {
                                    ...paymentOption,
                                    currencies: selected,
                                };
                            }
                            return paymentOption;
                        }));
                    } }))),
            React.createElement(Checkbox, { checked: paymentOption.hideOnDebtorweb, placeholder: lang.paymentOptions.hideOnDebtorweb, onChange: (e) => {
                    setPaymentOptions(paymentOptions.map((paymentOption, index) => {
                        if (index === i) {
                            return {
                                ...paymentOption,
                                hideOnDebtorweb: e.target.checked,
                            };
                        }
                        return paymentOption;
                    }));
                }, setting: true }),
            (() => {
                switch (paymentOption.type) {
                    case PaymentOptionType.BANKTRANSFER:
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Input, { value: paymentOption.details.bankName, placeholder: lang.paymentOptions.bankName, onChange: (e) => setPaymentOptionDetails(i, { bankName: e.target.value }) }),
                            React.createElement(Input, { value: paymentOption.details.registrationNumber, placeholder: lang.paymentOptions.registrationNumber, onChange: (e) => setPaymentOptionDetails(i, {
                                    registrationNumber: e.target.value,
                                }) }),
                            React.createElement(Input, { value: paymentOption.details.accountNumber, placeholder: lang.paymentOptions.accountNumber, onChange: (e) => setPaymentOptionDetails(i, {
                                    accountNumber: e.target.value,
                                }) })));
                    case PaymentOptionType.FI:
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Input, { value: paymentOption.details.creditorNumber, placeholder: lang.paymentOptions.fi, onChange: (e) => setPaymentOptionDetails(i, {
                                    creditorNumber: e.target.value,
                                }) }),
                            React.createElement(Checkbox, { placeholder: lang.paymentOptions.fikSyntax, checked: paymentOption.details.syntax ===
                                    FIKSyntax.PrincipalReferenceId, onChange: (e) => setPaymentOptionDetails(i, {
                                    syntax: e.target.checked
                                        ? FIKSyntax.PrincipalReferenceId
                                        : FIKSyntax.CaseIdAndZero,
                                }) }),
                            React.createElement(Checkbox, { placeholder: lang.paymentOptions
                                    .useAlternativeCreditorNumberInCaseVoucherTables, checked: typeof paymentOption.details
                                    .creditorNumberPerCaseVoucher === 'string', onChange: (e) => setPaymentOptionDetails(i, {
                                    creditorNumberPerCaseVoucher: e.target.checked
                                        ? ''
                                        : undefined,
                                }) }),
                            typeof paymentOption.details
                                .creditorNumberPerCaseVoucher === 'string' && (React.createElement(Input, { value: paymentOption.details.creditorNumberPerCaseVoucher, placeholder: lang.paymentOptions.fi, onChange: (e) => setPaymentOptionDetails(i, {
                                    creditorNumberPerCaseVoucher: e.target.value,
                                }) }))));
                    case PaymentOptionType.SWIFT:
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Input, { value: paymentOption.details.swiftCode, placeholder: lang.paymentOptions.swift, onChange: (e) => setPaymentOptionDetails(i, {
                                    swiftCode: e.target.value,
                                }) }),
                            React.createElement(Input, { value: paymentOption.details.ibanCode, placeholder: lang.paymentOptions.iban, onChange: (e) => setPaymentOptionDetails(i, {
                                    ibanCode: e.target.value,
                                }) })));
                    case PaymentOptionType.REEPAY:
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Input, { value: paymentOption.details.reepayPrivateKey, placeholder: lang.paymentOptions.reepayPrivateKey, onChange: (e) => setPaymentOptionDetails(i, {
                                    reepayPrivateKey: e.target.value,
                                }), sensitive: true }),
                            React.createElement(WebhookURL, { provider: Provider.Frisbii, paymentOption: paymentOption, setWebhookTroughAPI: true, collectorId: props.collectorId }),
                            React.createElement(Checkbox, { checked: paymentOption.details.visa, placeholder: lang.paymentOptions.visa, onChange: (e) => setPaymentOptionDetails(i, {
                                    visa: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.mastercard, placeholder: lang.paymentOptions.mastercard, onChange: (e) => setPaymentOptionDetails(i, {
                                    mastercard: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.dankort, placeholder: lang.paymentOptions.dankort, onChange: (e) => setPaymentOptionDetails(i, {
                                    dankort: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.mobilepay, placeholder: lang.paymentOptions.mobilepay, onChange: (e) => setPaymentOptionDetails(i, {
                                    mobilepay: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.swish, placeholder: lang.paymentOptions.swish, onChange: (e) => setPaymentOptionDetails(i, {
                                    swish: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.vipps, placeholder: lang.paymentOptions.vipps, onChange: (e) => setPaymentOptionDetails(i, {
                                    vipps: e.target.checked,
                                }), setting: true })));
                    case PaymentOptionType.FARPAY:
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Input, { value: paymentOption.details.farpayPrivateKey, placeholder: lang.paymentOptions.farpayPrivateKey, onChange: (e) => setPaymentOptionDetails(i, {
                                    farpayPrivateKey: e.target.value,
                                }), sensitive: true }),
                            React.createElement(WebhookURL, { provider: Provider.FarPay, paymentOption: paymentOption, collectorId: props.collectorId }),
                            React.createElement(Checkbox, { checked: paymentOption.details.visa, placeholder: lang.paymentOptions.visa, onChange: (e) => setPaymentOptionDetails(i, {
                                    visa: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.mastercard, placeholder: lang.paymentOptions.mastercard, onChange: (e) => setPaymentOptionDetails(i, {
                                    mastercard: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.dankort, placeholder: lang.paymentOptions.dankort, onChange: (e) => setPaymentOptionDetails(i, {
                                    dankort: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.mobilepay, placeholder: lang.paymentOptions.mobilepay, onChange: (e) => setPaymentOptionDetails(i, {
                                    mobilepay: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.betalingsservice, placeholder: lang.paymentOptions.betalingsservice, onChange: (e) => setPaymentOptionDetails(i, {
                                    betalingsservice: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.leverandorservice, placeholder: lang.paymentOptions.leverandorservice, onChange: (e) => setPaymentOptionDetails(i, {
                                    leverandorservice: e.target.checked,
                                }), setting: true })));
                    case PaymentOptionType.MOBILE_PEOPLE:
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Input, { value: paymentOption.details.hmac, placeholder: lang.paymentOptions.mobilePeopleHmac, onChange: (e) => setPaymentOptionDetails(i, {
                                    hmac: e.target.value,
                                }), sensitive: true }),
                            React.createElement(Input, { value: paymentOption.details.clientRef, placeholder: lang.paymentOptions.mobilePeopleClientRef, onChange: (e) => setPaymentOptionDetails(i, {
                                    clientRef: e.target.value,
                                }) }),
                            React.createElement(WebhookURL, { provider: Provider.MobilePeople, paymentOption: paymentOption, collectorId: props.collectorId }),
                            React.createElement(Checkbox, { checked: paymentOption.details.visa, placeholder: lang.paymentOptions.visa, onChange: (e) => setPaymentOptionDetails(i, {
                                    visa: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.mastercard, placeholder: lang.paymentOptions.mastercard, onChange: (e) => setPaymentOptionDetails(i, {
                                    mastercard: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.dankort, placeholder: lang.paymentOptions.dankort, onChange: (e) => setPaymentOptionDetails(i, {
                                    dankort: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.mobilepay, placeholder: lang.paymentOptions.mobilepay, onChange: (e) => setPaymentOptionDetails(i, {
                                    mobilepay: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.betalingsservice, placeholder: lang.paymentOptions.betalingsservice, onChange: (e) => setPaymentOptionDetails(i, {
                                    betalingsservice: e.target.checked,
                                }), setting: true }),
                            React.createElement(Checkbox, { checked: paymentOption.details.leverandorservice, placeholder: lang.paymentOptions.leverandorservice, onChange: (e) => setPaymentOptionDetails(i, {
                                    leverandorservice: e.target.checked,
                                }), setting: true })));
                    case PaymentOptionType.LINK_TO_OWN_PAYMENT:
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Input, { value: paymentOption.details.url, placeholder: lang.paymentOptions.url, onChange: (e) => setPaymentOptionDetails(i, {
                                    url: e.target.value,
                                }) }),
                            React.createElement(Input, { value: paymentOption.details.titleToDebtor, placeholder: lang.paymentOptions.titleToDebtor, onChange: (e) => setPaymentOptionDetails(i, {
                                    titleToDebtor: e.target.value,
                                }) }),
                            React.createElement(Input, { value: paymentOption.details.descriptionToDebtor, placeholder: lang.paymentOptions.descriptionToDebtor, onChange: (e) => setPaymentOptionDetails(i, {
                                    descriptionToDebtor: e.target.value,
                                }) })));
                }
            })()))),
        React.createElement(Select, { value: "", style: { cursor: 'pointer' }, onChange: (e) => {
                const type = e.target.value;
                if (!Object.values(PaymentOptionType).includes(type)) {
                    return;
                }
                let details;
                switch (type) {
                    case PaymentOptionType.BANKTRANSFER:
                        details = {
                            bankName: '',
                            registrationNumber: '',
                            accountNumber: '',
                        };
                        break;
                    case PaymentOptionType.FI:
                        details = {
                            creditorNumber: '',
                            syntax: FIKSyntax.CaseIdAndZero,
                        };
                        break;
                    case PaymentOptionType.SWIFT:
                        details = {
                            ibanCode: '',
                            swiftCode: '',
                        };
                        break;
                    case PaymentOptionType.REEPAY:
                        details = {
                            reepayPrivateKey: '',
                            visa: true,
                            mastercard: true,
                            dankort: true,
                            mobilepay: true,
                            swish: false,
                            vipps: false,
                        };
                        break;
                    case PaymentOptionType.FARPAY:
                        details = {
                            farpayPrivateKey: '',
                            betalingsservice: true,
                            leverandorservice: true,
                            mobilepay: true,
                            visa: true,
                            mastercard: true,
                            dankort: true,
                        };
                        break;
                    case PaymentOptionType.MOBILE_PEOPLE:
                        details = {
                            hmac: '',
                            clientRef: '',
                            visa: true,
                            mastercard: true,
                            dankort: true,
                            betalingsservice: true,
                            leverandorservice: true,
                            mobilepay: true,
                        };
                        break;
                    case PaymentOptionType.LINK_TO_OWN_PAYMENT:
                        details = {
                            url: '',
                            titleToDebtor: '',
                            descriptionToDebtor: '',
                        };
                        break;
                    default:
                        throw 'Type not supported';
                }
                setPaymentOptions(
                // @ts-ignore
                [
                    ...paymentOptions,
                    {
                        id: crypto.randomUUID(),
                        type,
                        details,
                    },
                ]);
            } },
            React.createElement("option", null,
                "- ",
                lang.paymentOptions.addNew,
                " -"),
            Object.values(PaymentOptionType).map((type) => (React.createElement("option", { key: type, value: type }, lang.paymentOptionTypes[type]))))));
};
const PaymentOptionsStyled = styled.div `
  padding: ${THEME.GRID_SPACING}px;
  margin-bottom: ${THEME.GRID_SPACING}px;
  border-radius: 3px;
  background-color: #e6e6e6;
  position: relative;
`;
export default PaymentOptions;
const WebhookURL = (props) => {
    const tenantId = useTenantId();
    const lang = useSelector((s) => s.lang);
    const url = `${APIBASE}${tenantId ? genWebhookEventAPIPath(tenantId, props.provider) : null}`;
    const setWebhookMutation = useMutation(async () => {
        await paymentMethodsAPI.setWebhookUrl(props.provider, props.paymentOption.id);
        q.invalidate(keys.write.modify(collectorsEntity, props.collectorId));
    }, {
        onSuccess: () => {
            notification({
                title: 'Successfully set webhook URL',
            });
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.webhook);
        },
    });
    return (React.createElement(ExclusiveContent, null,
        React.createElement(Alert, { message: 'Webhook event URL', description: React.createElement(React.Fragment, null,
                React.createElement(CopyToClipboard, { text: url }, url),
                props.setWebhookTroughAPI && (React.createElement(React.Fragment, null,
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement(Button, { loading: setWebhookMutation.isLoading, disabled: props.paymentOption.webhookEventUrlConfigured, onClick: () => setWebhookMutation.mutate() }, "Set webhook URL")))), style: {
                background: THEME.COLOR_PRIMARY,
            } })));
};
//# sourceMappingURL=PaymentOptions.js.map